import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faEye,
  faEyeSlash,
  faLock,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../context/AuthContext";
import { Button, Field } from "../components/UI";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(form.email) || !form.password)
      return setError("Enter a valid email and password.");
    setBusy(true);
    setError("");
    try {
      await login(form);
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="login-page">
      <section className="login-story">
        <div className="brand login-brand">
          <span className="brand-mark">K</span>
          <div>
            <strong>FlowChat</strong>
            <small>Website intelligence</small>
          </div>
        </div>
        <div className="story-copy">
          <span className="eyebrow">Multi-website control plane</span>
          <h1>Every answer, grounded in the right website.</h1>
          <p>
            Manage tenant knowledge, assistant behavior, and conversation
            signals from one carefully scoped workspace.
          </p>
          <div className="scope-diagram">
            <div className="scope-core">
              <FontAwesomeIcon icon={faShieldHalved} />
              Admin
            </div>
            {["A", "B", "C"].map((label, index) => (
              <div className={`scope-site site-${index}`} key={label}>
                <span>{label}</span>
                <small>Isolated knowledge</small>
              </div>
            ))}
          </div>
        </div>
        <small className="story-foot">
          Website intelligence, precisely scoped.
        </small>
      </section>
      <section className="login-form-wrap">
        <form className="login-card" onSubmit={submit}>
          <span className="login-icon">
            <FontAwesomeIcon icon={faLock} />
          </span>
          <span className="eyebrow">Private administration workspace</span>
          <h2>Welcome back</h2>
          <p>Sign in to manage your websites and assistants.</p>
          {error && (
            <div className="form-alert" role="alert">
              {error}
            </div>
          )}
          <Field label="Email address">
            <input
              type="email"
              autoComplete="email"
              placeholder="admin@company.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </Field>
          <Field label="Password">
            <div className="input-with-action">
              <input
                type={show ? "text" : "password"}
                autoComplete="current-password"
                placeholder="Enter your password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
              <button
                type="button"
                onClick={() => setShow(!show)}
                aria-label={show ? "Hide password" : "Show password"}
              >
                <FontAwesomeIcon icon={show ? faEyeSlash : faEye} />
              </button>
            </div>
          </Field>
          <Button type="submit" icon={faArrowRight} disabled={busy}>
            {busy ? "Signing in…" : "Sign in securely"}
          </Button>
          <small className="secure-note">
            Session access is protected by an HTTP-only cookie.
          </small>
        </form>
      </section>
    </main>
  );
}
